// extracted by mini-css-extract-plugin
export default {"container":"BookRerollComponent_container__xck9d","premiumIcon":"BookRerollComponent_premiumIcon__do-JF"};